import React from 'react'
import PropTypes from 'prop-types'
import useIntersection from 'hooks/useIntersection'

const noop = () => {}

const VisibilitySensor = ({ disabled, children, onChange = noop, root, rootMargin, threshold, ...props }) => {
  const containerRef = React.useRef()

  const [entry, setTarget] = useIntersection({ root, rootMargin, threshold, disabled })

  // TODO: Use useLastestRef custom hook once it's merged to master
  const onChangeRef = React.useRef(onChange)

  React.useEffect(() => {
    onChangeRef.current = onChange
  })

  React.useEffect(() => {
    setTarget(containerRef.current)
    return () => setTarget(null)
  }, [setTarget])

  React.useEffect(() => {
    if (entry) {
      onChangeRef.current(entry.isIntersecting)
    }
  }, [entry])

  return (
    <div ref={containerRef} {...props}>
      {children}
    </div>
  )
}

VisibilitySensor.propTypes = {
  onChange: PropTypes.func,
  rootMargin: PropTypes.string,
  root: PropTypes.object,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)
  ]),
  disabled: PropTypes.bool
}

export default VisibilitySensor
